import React from 'react';
import { dashboardMuted } from '../../../theme/dashboardLayout';
import { scoreBandLegendItems } from '../scoreBandColor';

function CoverageDayColorLegend(): React.ReactElement {
  return (
    <div
      role="list"
      aria-label="Coverage colour bands for weekday buttons"
      className={`mb-1 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 ${dashboardMuted} text-[11px]`}
    >
      {scoreBandLegendItems().map((item) => (
        <div key={item.label} role="listitem" className="inline-flex items-center gap-1.5">
          <span
            aria-hidden="true"
            className="inline-block h-3 w-3 rounded-full ring-1 ring-inset ring-portal-teal/10"
            style={{ backgroundColor: item.color }}
          />
          <span>
            {item.label} {item.range}%
          </span>
        </div>
      ))}
    </div>
  );
}

export default CoverageDayColorLegend;
